import { CheckIcon, PlusIcon } from '@heroicons/react/20/solid';
import {
  PlayerImage,
  PlayerName,
  PlayerProfile,
  PlayerSecondaryHeader,
  PlayerSubheader
} from '@library/components/player';
import { IconButton } from '@library/components/buttons';
import type { OddsType } from '@library/types/projection';
import { OddsTypeIndicator } from '@library/components/OddsTypeIndicator';
import type { PlayerPackProjection } from '@library/types/playerPacks/playerPacks';
import { useCallback } from 'react';

export const PlayerPackAddProjectionRow = ({
  isProjectionPicked,
  projection,
  onAddProjection
}: {
  isProjectionPicked: boolean;
  projection: PlayerPackProjection;
  onAddProjection: (projection: PlayerPackProjection) => void;
}) => {
  const handleAddProjection = useCallback(() => {
    onAddProjection(projection);
  }, [onAddProjection, projection]);

  return (
    <div className="flex h-[49px] w-full items-center justify-between px-4">
      <PlayerProfile
        className="flex min-w-60 items-center gap-4"
        imageUrl={projection.playerImageUrl}
        name={projection.playerName}
        subheader={`${projection.projectionValue} ${projection.statType}`}
        secondaryHeader={projection.gameDisplay}
      >
        <PlayerImage className="bg-soFresh-120 size-[49px] rounded-lg" />

        <div className="flex h-12 flex-col items-start justify-start">
          <PlayerName className="font-heebo text-soClean-100 text-center text-sm font-medium leading-tight tracking-tight" />
          <div className="flex flex-row items-center gap-4">
            <PlayerSubheader className="text-soClean-100 text-xs font-medium leading-4 tracking-tight" />
            <OddsTypeIndicator
              oddsType={projection.oddsType as OddsType}
              className="size-3"
            />
          </div>
          <PlayerSecondaryHeader className="text-soClean-170 font-heebo text-xs font-light leading-4 tracking-tight" />
        </div>
      </PlayerProfile>
      {isProjectionPicked ? (
        <div className="border-soFresh-140 bg-stankonia-100 rounded-md border p-1">
          <CheckIcon className="text-soClean-100 size-5" />
        </div>
      ) : (
        <IconButton
          handleOnClick={handleAddProjection}
          className="border-soFresh-140 rounded-md border p-1"
        >
          <PlusIcon className="text-soClean-100 size-5" />
        </IconButton>
      )}
    </div>
  );
};
